@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="scorecast-option-group">
    <div #dropdownWrapper class="flex-layout scorecast-option-group-body">
        <div class="scorecast-option-group-col">
            <span class="scorecast-option-group-name">{{ marketTitle || messages.goalScorerTitle }}</span>
            <ms-multi-column-dropdown
                #marketDropdown
                dropdownPlacement="left"
                [groups]="players"
                [active]="selectedPlayer"
                [images]="images"
                [viewport]="dropdownMenuViewport"
                (optionChange)="onPlayerChange($event)"
                (toggleDropdownState)="onPlayerDropdownClick($event)" />
        </div>
        <div class="scorecast-option-group-col">
            <span class="scorecast-option-group-name">{{ optionTitle || messages.scoreTitle }}</span>
            <ms-multi-column-dropdown
                #optionDropdown
                class="scorecast-option-groups-scores"
                textAlignment="center"
                dropdownPlacement="right"
                [groups]="options"
                [any]="anyOtherOption"
                [active]="selectedOption"
                [viewport]="dropdownMenuViewport"
                (toggleDropdownState)="onOptionDropdownClick($event)"
                (optionChange)="onOptionChange($event)" />
        </div>
    </div>
    <ms-scorecast-footer
        [optionGroup]="optionGroup"
        [activeEventOption]="activeEventOption"
        [event]="event"
        [warningMessage]="warningMessage"
        [tracking]="tracking"
        [trackingModuleType]="trackingModuleType"
        [sourceOfPick]="sourceOfPick"
        [betDetails]="betDetails" />
</div>
